import React, { useState, useEffect } from 'react';

import * as AppData from '../../../../data/App.data';
import { Link } from 'react-router-dom';

const StyleFabricCategoryComponent = props => {
    const { selectedCategoryCode, setCategory, subcategoryList,
        onClickBtnCloseStyleFabricCategoryMenu } = props;

    return (
        <div className={`sub-gnb ${props.isOnShowFabricStyleSubGnb ? "on" : ""}`}>
            <div className="content">
                <button
                    onClick={onClickBtnCloseStyleFabricCategoryMenu}
                    class="btn-close-modal black">
                    <i></i>
                </button>
                <div className="logo"></div>
                <div className="header">
                    {selectedCategoryCode === 'MEN' ?
                        <div className="con">
                            <a onClick={evt => setCategory('ACC')}
                                className="link link-left">
                                <i class='arrow-left'></i>ACCESSORIES
                            </a>
                            <div className="title">MEN's</div>
                            <a onClick={evt => setCategory('WOMEN')}
                                className="link link-right">
                                WOMEN's <i class='arrow-right'></i>
                            </a>
                        </div>
                        : null}
                    {selectedCategoryCode === 'WOMEN' ?
                        <div className="con">
                            <a onClick={evt => setCategory('MEN')}
                                className="link link-left">
                                <i class='arrow-left'></i>MEN's
                            </a>
                            <div className="title">WOMEN's</div>
                            <a onClick={evt => setCategory('ACC')}
                                className="link link-right">
                                ACCESSORIES <i class='arrow-right'></i>
                            </a>
                        </div>
                        : null}
                    {selectedCategoryCode === 'ACC' ?
                        <div className="con">
                            <a onClick={evt => setCategory('WOMEN')}
                                className="link link-left">
                                <i class='arrow-left'></i>WOMEN's
                            </a>
                            <div className="title">ACCESSORIES</div>
                            <a onClick={evt => setCategory('MEN')}
                                className="link link-right">
                                MEN's <i class='arrow-right'></i>
                            </a>
                        </div>
                        : null}
                </div>
                <div className="body">
                    <div className="list">
                        <ul>
                            {subcategoryList.map((item, idx) =>
                                <li key={idx}>
                                    <div
                                        onClick={evt => props.onClickBtnCategory(item)}
                                        className="item">
                                        <div className="img">
                                            <img
                                                src={item.imageUrl}
                                                alt={item.names['en']}
                                            />
                                        </div>
                                        <div className="name">{item.names['en']}</div>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StyleFabricCategoryComponent;